var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var ModalTitle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  text-align: left;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: #fff;\n  margin-bottom: 12px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #3a3c3e;\n  font-family: \"Inter\";\n  font-weight: 700;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  text-align: left;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: #fff;\n  margin-bottom: 12px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #3a3c3e;\n  font-family: \"Inter\";\n  font-weight: 700;\n"])));
export var ModalContents = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  min-width: 230px;\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"], ["\n  min-width: 230px;\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"])));
export var modalStyle = {
    overlay: {
        zIndex: 1020,
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        maxWidth: "100%",
        maxHeight: "calc(100% - 50px)",
        overflowY: "auto",
        borderRadius: "12px",
        border: "none",
        background: "#2a2c2e",
    },
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Modal.styled.js.map